// src/utils/versione.js
// Il numero del pacchetto dell'app (lo stesso dei file consegnati: W…). Si vede in fondo a
// «La mia area» e in Impostazioni → Profilo: così si capisce subito quale versione sta
// girando su un computer o un telefono (per esempio se il browser mostra ancora quella
// vecchia). Va aggiornato a ogni consegna.
export const VERSIONE_APP = "W453";
export const DATA_VERSIONE = "31/10/2026";
